/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Silly_Sharp_Mink_ComposeInputs */

const es_silly_sharp_mink_compose = /** @type {(inputs: Silly_Sharp_Mink_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te olvidaste la contraseña?`)
};

const gl_silly_sharp_mink_compose = /** @type {(inputs: Silly_Sharp_Mink_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esqueciches o teu contrasinal?`)
};

const en_silly_sharp_mink_compose = /** @type {(inputs: Silly_Sharp_Mink_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot your password?`)
};

/**
* | output |
* | --- |
* | "Forgot your password?" |
*
* @param {Silly_Sharp_Mink_ComposeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const silly_sharp_mink_compose = /** @type {((inputs?: Silly_Sharp_Mink_ComposeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Silly_Sharp_Mink_ComposeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_silly_sharp_mink_compose(inputs)
	if (locale === "en") return en_silly_sharp_mink_compose(inputs)
	return es_silly_sharp_mink_compose(inputs)
});